import React from "react";
import styled from "styled-components";
import Box from "../../../../elements/v2/Box/Box";
import { H2 } from "../../../../elements/v2/Typography/Heading";
import ListingSlider from "../../../../composites/v2/ListingSlider/ListingSlider";
import { Hit, HitRecord, ListingCardData } from "../../../../../utils/algolia/mapHitToListing";
import { SearchResponse } from "@algolia/client-search/dist/node";

type Props = {
  heading: string;
  searchResults?: SearchResponse<HitRecord>;
  handleListingClick?: (listing: ListingCardData) => void;
  countryCode?: string;
};

const MINIMUM_NUMBER_ITEMS_TO_SHOW_SLIDER = 2;

export default function FilteredProductSlider({
  heading,
  searchResults,
  handleListingClick,
  countryCode,
}: Props) {
  if (!searchResults) return null;

  const { nbHits, hits } = searchResults;

  if (nbHits < MINIMUM_NUMBER_ITEMS_TO_SHOW_SLIDER) return null;

  return (
    <Box py={4}>
      <Heading>{heading}</Heading>
      <ListingSlider
        mt={4}
        hits={hits as Hit[]}
        handleListingClick={handleListingClick}
        countryCode={countryCode}
      />
    </Box>
  );
}

const Heading = styled(H2)`
  font-family: Lora, serif;
`;
